// shared helper, put in Utils
export const equalizeColumns = (root, columnClasses) => {
  if (!root) return;
  columnClasses.forEach((className) => {
    const els = root.querySelectorAll(`.${className}`);
    els.forEach((el) => {
      el.style.width = "";
      el.style.minWidth = "";
      el.style.maxWidth = "";
    });
    let max = 0;
    els.forEach((el) => {
      max = Math.max(max, el.getBoundingClientRect().width);
    });
    if (max === 0) return; // table hidden at this breakpoint — skip
    els.forEach((el) => {
      el.style.width = `${max}px`;
      el.style.minWidth = `${max}px`;
      el.style.maxWidth = `${max}px`;
    });
  });
};
